(function($)
{

    $.fn.fileaccept = function(options)
    {
        // build main options before element iteration
        var opts = $.extend({}, $.fn.fileaccept.defaults, options);

        return this.each(function() {
            var $this = $(this);
            // build element specific options
            var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

            $this.bind('change', function() {
                if(!validateSelectedFile($this))
                {
                    unsupportedFileType($this);
                    if(!$.browser.msie){
                        $this.val("").change();
                    }
                }
                return true;
            });
        });
    };
    //
    // plugin defaults
    //
    $.fn.fileaccept.defaults = {
    };

    function validateSelectedFile($fileInput)
    {
        var filePath = $fileInput.val();
        var accept = $fileInput.attr("accept");
        if(filePath.length > 0 && accept.length > 0)
        {
            var exts = accept.split(",");
            var ext = filePath.substring(filePath.lastIndexOf(".") + 1).toLowerCase();
            return $.inArray(ext, exts) >= 0;
        }
        return true;
    }

    function unsupportedFileType($fileInput)
    {
        alert(translate("The file type you are attempting to upload is unsupported"));
    }

})(jQuery);